import { UsuarioSeg } from './usuario-seg';

export class ProcuradoriaComentario {
  id: number;
  usuario: UsuarioSeg;
  idEtapaProcuradoria: number;
  conteudo: string;
  dataCriacao: Date;
  dataUltimaAlteracao: Date;
}